import { ActivatedRouteSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { OrganizationsStore } from '../store/organizations.store';
import { LocationsStore } from '../../locations/store/locations.store';
import { EnergyInterfacesStore } from '../../energy-interfaces/stores/energy-interfaces.store';
import { SupplierContractStore } from '../../supplier-contracts/stores/supplier-contracts.store';
import { ParseRequestsStore } from '../../parse-requests/stores/parse-requests.store';
import { SupplierContractForecastStore } from '../../supplier-contracts/stores/supplier-contract-forecast.store';
import { DocumentsStore } from '../../documents/stores/documents.store';
import { ConsumptionStore } from '../../analysis/stores/consumption.store';
import { SupplierContractWizardStore } from '../../supplier-contracts/stores/supplier-contract-wizard.store';

export const organizationLoadedGuard = async (route: ActivatedRouteSnapshot) => {
  const orgaStore = inject(OrganizationsStore);
  const organizationId = route.paramMap.get('organizationId');
  if (!organizationId) {
    return false;
  }
  if (!orgaStore.entities()[organizationId]) {
    orgaStore.load(organizationId);
  }
  if (!orgaStore.entities()[organizationId]?.childStats) {
    orgaStore.loadChildStats(organizationId);
  }
  if (orgaStore.selected()?.id !== organizationId) {
    orgaStore.select(organizationId);
    inject(LocationsStore).reset();
    inject(EnergyInterfacesStore).reset();
    inject(SupplierContractStore).reset();
    inject(SupplierContractWizardStore).reset();
    inject(ParseRequestsStore).reset();
    inject(SupplierContractForecastStore).reset();
    inject(DocumentsStore).reset();
    inject(ConsumptionStore).reset();
  }
  return true;
};
